import { useAbility } from '@casl/react';

import { canAskFromAbility } from '../../ability-from-session';

export { askResources } from '../../ability-from-session';

/**
 * Custom hook to check if the current user can ask
 * @returns True if the user can ask, false otherwise
 */
export const useCanAsk = () => {
  const ability = useAbility();
  return canAskFromAbility(ability);
};
